import { render, staticRenderFns } from "./FilterableView.vue?vue&type=template&id=22a799fe"
import script from "./FilterableView.vue?vue&type=script&lang=js"
export * from "./FilterableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports